import apiClient from './apiClient';
import { UPDATE_COMPANY_REGISTRATION_URL } from './apiUrl';

const postStatusCompanyRegistrationApi = data => {
  return apiClient.post(UPDATE_COMPANY_REGISTRATION_URL, data);
};

export default postStatusCompanyRegistrationApi;
